const PACKAGE_LICENSE = {
    ATTRIBUTION: 'Attribution',
    ATTRIBUTION_NONCOMMERCIAL: 'Attribution-NonCommercial',
    PERSONAL_USE: 'Personal Use',
};

export default PACKAGE_LICENSE;
